import { Component } from '@angular/core';
import {faFacebook, faInstagram, faWhatsapp, faYoutube} from "@fortawesome/free-brands-svg-icons";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {RouterLink, RouterLinkActive} from "@angular/router";

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [
        FontAwesomeModule,
        RouterLink,
        RouterLinkActive
    ],
    standalone: true
})
export class FooterComponent {

    date = new Date().getFullYear();

    protected readonly faWhatsapp = faWhatsapp;
    protected readonly faInstagram = faInstagram;
    protected readonly faYoutube = faYoutube;
    protected readonly faFacebook   = faFacebook;
}